import { render } from "./CreateTaskModal.vue?vue&type=template&id=3283ed7d"
import script from "./CreateTaskModal.vue?vue&type=script&lang=js"
export * from "./CreateTaskModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__